module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('table', {
    staticStyle: {
      "margin-top": "5em"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('img', {
    attrs: {
      "alt": "inline",
      "src": "images/pipe.jpg"
    }
  })]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding-right": "1.5em",
      "padding-left": "1.5em"
    },
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "part-lab"
  }, [_c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("Section 1")])]), _vm._v(" "), _c('h2', {
    staticClass: "part",
    attrs: {
      "id": "part01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("A LIFE OF PURPOSE THROUGH PROSPERITY")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('img', {
    attrs: {
      "alt": "inline",
      "src": "images/pipe.jpg"
    }
  })])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a2b3892","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part01.vue
// module id = 81
// module chunks = 0